import styled from 'styled-components';
import { windowMaxWidth } from './breakpoints';

const SidebarNav = styled.nav`
  display: flex;

  /* Grow to fill a tall sidebar (space-between then pins the footer to the bottom), but never
     shrink below the content — so a short viewport scrolls with the bottom padding reachable. */
  flex: 1 0 auto;
  flex-direction: column;
  justify-content: space-between;
  padding: 20px 0;
`;

const SidebarTopSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

const SidebarSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
`;

const SidebarSectionTitle = styled.div`
  color: var(--greyscale-shade);
  font-size: var(--font-size-small);
  font-weight: var(--font-weight-medium);
  letter-spacing: 0.5px;
  line-height: var(--font-line-height-small);
  padding: 0 20px;
  text-transform: uppercase;

  @media ${windowMaxWidth.splitScreen} {
    display: none;
  }
`;

const SidebarItemsGroup = styled.div`
  display: flex;
  flex-direction: column;
`;

const SidebarDivider = styled.div`
  border-top: 1px solid var(--greyscale-dark-white);
  margin: 0 20px;
`;

const SidebarItem = styled.button.attrs({ type: 'button' })`
  align-items: center;
  background: none;
  border: none;
  color: ${({ $active }) => ($active ? 'var(--greyscale-blackish)' : 'var(--greyscale-shade)')};
  cursor: pointer;
  display: flex;
  font: inherit;
  font-weight: ${({ $active }) => ($active ? 'var(--font-weight-medium)' : 'inherit')};
  gap: 6px;
  padding: 10px 15px 10px 20px;
  text-align: left;
  width: 100%;

  svg,
  svg * {
    stroke: ${({ $active }) => ($active ? 'var(--greyscale-blackish)' : 'var(--greyscale-shade)')};
  }

  &:hover {
    color: var(--greyscale-blackish);

    svg,
    svg * {
      stroke: var(--greyscale-blackish);
    }
  }

  @media ${windowMaxWidth.splitScreen} {
    justify-content: center;
    padding: 10px;
  }
`;

const SidebarItemIcon = styled.div`
  align-items: center;
  display: flex;
  flex-shrink: 0;
  height: 20px;
  justify-content: center;
  width: 20px;
`;

const SidebarItemLabel = styled.span`
  font-size: var(--font-size-heading-4);
  font-weight: var(--font-weight-medium);
  line-height: var(--font-line-height-regular);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;

  @media ${windowMaxWidth.splitScreen} {
    display: none;
  }
`;

const SidebarFooterLink = styled.a`
  align-items: center;
  background: none;
  border: none;
  color: var(--primary-oqio-blue);
  cursor: pointer;
  display: flex;
  font-size: var(--font-size-regular);
  font-weight: var(--font-weight-medium);
  gap: 6px;
  line-height: var(--font-line-height-regular);
  padding: 10px 20px 0;
  text-decoration: none;
  width: 100%;

  svg,
  svg * {
    stroke: var(--primary-oqio-blue);
  }

  &:disabled {
    cursor: not-allowed;
    opacity: 0.5;
  }

  &:hover:not(:disabled) {
    color: var(--primary-oqio-blue-hover);

    svg,
    svg * {
      stroke: var(--primary-oqio-blue-hover);
    }
  }

  @media ${windowMaxWidth.splitScreen} {
    justify-content: center;
    padding: 10px 0 0;
  }
`;

const SidebarFooterLinkLabel = styled.span`
  @media ${windowMaxWidth.splitScreen} {
    display: none;
  }
`;

const AdministrationSidebarLayout = {
  SidebarNav,
  SidebarTopSection,
  SidebarSection,
  SidebarSectionTitle,
  SidebarItemsGroup,
  SidebarDivider,
  SidebarItem,
  SidebarItemIcon,
  SidebarItemLabel,
  SidebarFooterLink,
  SidebarFooterLinkLabel
};

export default AdministrationSidebarLayout;
